import {AbsoluteCenter, Box, Heading} from '@chakra-ui/react';
import React from 'react';
import ButtonMinor from '../../../components/ButtonMinor';
import {sendAudioClick} from '../../../vuplex';
import {
  fontFamily,
  getWorldTypeAccentColor,
  newCraterRunRoomName,
  newSpaceportRoomName,
  worldTypes,
} from './config';

const newWorldNames = {
  [worldTypes.craterRun]: newCraterRunRoomName,
  [worldTypes.spaceport]: newSpaceportRoomName,
};

const NewWorldCard = ({
  label = null,
  leftIcon = null,
  labelSuffix = null,
  onClick = () => {
  },
  rightIcon = null,
  worldType,
}) => {
  const accentColor = getWorldTypeAccentColor({
    rules: {
      worldType,
    },
  });

  return (
    <ButtonMinor
      bg={accentColor}
      border={`4px solid ${accentColor}`}
      borderRadius="none"
      h="5em"
      p={0}
      onClick={(evt) => {
        onClick(worldType);
        sendAudioClick(evt);
      }}
      w="full"
    >
      <Box
        bg="none"
        fontFamily={fontFamily}
        h="full"
        p={2}
        position="relative"
        w="full"
      >
        {leftIcon && (
          <Box left={4} position="absolute" top="50%" transform="translateY(-50%)">
            {leftIcon}
          </Box>
        )}

        <AbsoluteCenter>
          <Heading
            color="black"
            fontSize="1.1em"
            fontFamily="'Press Start 2P', system-ui"
            fontWeight="normal"
            textTransform="uppercase"
          >
            {label || newWorldNames[worldType]}{labelSuffix && <> {labelSuffix}</>}
          </Heading>
        </AbsoluteCenter>

        {rightIcon && (
          <Box position="absolute" right={4} top="50%" transform="translateY(-50%)">
            {rightIcon}
          </Box>
        )}
      </Box>
    </ButtonMinor>
  );
};

export default NewWorldCard;
